import { useState } from "react";
import { useLocalStorage } from "./useLocalStorage";
import moment from 'jalali-moment';

//import {moment as jm}  from 'jalali-moment';
const useCommon = () => {
  const [user] = useLocalStorage("user", null);
  const [showPassword, setShowPassword] = useState(false)
  const isRole = (roles) => {
    return user?.user?.roles?.some((r) => roles?.includes(r.value)) || roles?.includes(0);
  }

  const getUserID = (id) => {
    return user?.user?.id === id
  }

  const ddmmyyhhmmA = (date) => {
    return moment(date).format('DD/MM/yyyy, hh:mm a');
  }

  const getDate = (date, format = "DD/MM/yyyy") => {
    return date ? moment(date).format(format) : '';
  }

  const numConvertAndRevrse = (n) => {
    let m = n ? n.toString() : '';
    return m.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]).split("").reverse().join("")
  }

  const reverseDigits = (str)=> {

    if (!str) return str;
    const digits = str.match(/[\d۰-۹]/g);
    if(!digits) return str;
     digits.reverse();
    return str.replace(/[\d۰-۹]/g, () => digits.shift());
  }


  const dateConvert = (date, flag = true, fmat = false) => {// fa to en // en to fa
   // console.log("dateConvert: ", date)
    let format = 'jYYYY/jMM/jDD';
    if (fmat) format = format + ', hh:mm a';
    return date ? flag ? moment(date, 'jYYYY/jMM/jDD hh:mm:ss').format('YYYY-MM-DD hh:mm:ss') : moment(date, 'YYYY-MM-DDTHH:mm:ssZZ').format(format) : '';
    //return date ? flag ? moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD HH:mm:ss') : moment(date, 'YYYY-MM-DDTHH:mm:ssZZ').locale('fa').format(format) : '';
  }

  const getShamshiDate = (date) => {
    console.log("getShamshiDate ", date);

    return date ? numConvertAndRevrse(moment(date, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('YYYY / MM / DD')) : ''
  }


  const ENumConvert = (n) => n.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])

  const removeDoubleSpaces = (t) => t.replace(/\s+/g, ' ')

  const NumberFormatter = (value) => {
    const options = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    };
    return value ? Number(value).toLocaleString('en', options) : ''
  };

  const fromNow = (date) => {

    return date ? moment(date).fromNow() : null
  }


  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  const convetDateInObject = (data, value) => {
    const date = Object.keys(data).find(key => key === value)
    if (date) { // convert shamsi date to miladi
      console.log("test date created", date);
      data[date] = dateConvert(data[date])
    }
    return data
  }

  const covertNumDrToEn = (num)=>{
      return num?.replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
  }

  const capitalizeWords = (str) => { //
    return str?.toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return {
    isRole, getDate, ddmmyyhhmmA, showPassword, setShowPassword,
    numConvertAndRevrse, reverseDigits, ENumConvert, getShamshiDate,
    removeDoubleSpaces, NumberFormatter, formatBytes,covertNumDrToEn,
    getUserID, dateConvert, convetDateInObject, fromNow, capitalizeWords
  }
}

export default useCommon;